/* eslint-disable */
import React from 'react';

const IconClose = () => (
    <svg
        enableBackground="new 0 0 14 14"
        height="14px"
        id="cross"
        version="1.1"
        viewBox="0 0 32 32"
        width="14px"
    >
        <path
            d="M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z"
            fill="#121313" id="Close"/>
    </svg>
);

export default IconClose;
// <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Combined Shape</title><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="buttons/blue-button-link-reset" transform="translate(-77.000000, -8.000000)" stroke="#053B80" stroke-width="2"><path d="M79,10 L87,18 M87,10 L79,18" id="Combined-Shape"></path></g></g></svg>